import React, { useState } from "react"
import Button, { IconButton } from "@jobintrans/base-ui.components.atoms.button"
import { AdminTransactionType } from "@jobintrans/base-ui.types.api"
import Modal from "@jobintrans/base-ui.components.molecules.modal"
import Input from "@jobintrans/base-ui.components.atoms.input"
import { useForm } from "react-hook-form"
import { WEBSITE_REGEX } from "@jobintrans/base-ui.utils.regex"
import { useTranslation } from "react-i18next"
import { Box } from "@jobintrans/base-ui.components.atoms._atoms"
import { useQueryClient } from "@tanstack/react-query"
import {
  AdminTransactionsService,
  GeolocationService,
} from "@jobintrans/base-ui.services.api-service"
import { SentryService } from "services/SentryService"

const TransactionInvoiceButton = ({ data }: { data: AdminTransactionType }) => {
  const { t } = useTranslation(["form"])
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)

  const queryClient = useQueryClient()

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    setError,
    reset,
    unregister,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      url: data.invoiceUrl || "",
    },
  })

  const isDisabled = data.value === 0
  const isActive = isDisabled || !!data.invoiceUrl

  const onSubmit = async (el: { url: string }) => {
    try {
      setLoading(true)
      await AdminTransactionsService.addInvoiceUrl(data.id, el.url)
      queryClient.refetchQueries({ queryKey: ["transactions"] })
    } catch (e) {
      SentryService.error("[ERROR AdminTransactionsService.addInvoiceUrl]:", e)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <IconButton
        $marginLeft="XS"
        icon="check"
        ariaLabel="Add invoice URL"
        $size="45px"
        $iconSize="M"
        $borderRadius="borderRadius"
        $borderColor={isActive ? "primary" : "border"}
        $background={isActive ? "primaryBackground" : "background"}
        $color={isActive ? "primary" : "second"}
        onClick={() => setShow(true)}
        disabled={isDisabled}
      />
      <Modal icon="share" show={show} setShow={setShow} title="Link do faktury">
        <Box>
          <Input
            name="url"
            error={errors?.url}
            value={watch("url")}
            rhf={register("url", {
              required: t("required", { ns: "form" }),
            })}
            $marginBottom="S"
          />
          <Button icon="save" onClick={handleSubmit(onSubmit)} $width="100%" loading={loading}>
            Zapisz
          </Button>
        </Box>
      </Modal>
    </>
  )
}

export default TransactionInvoiceButton
